import { BatchEditCampaignPage } from 'components/BatchEditCampaign/BatchEditCampaignPage';
import { ModifyLimitationStateContentModel } from './ModifyLimitationStateContentModel';
import { EditLimitation } from 'containers/Limitations/EditLimitation';
import styles from './modifyLimitationStateContent.module.scss';
import { renderAgeAndGender } from 'containers/RtbCampaigns/RtbCampaignSetupFlow/FlowSteps/RtbAgeAndGender';

export const ModifyLimitationStateContent: React.FC<{
  model: () => ModifyLimitationStateContentModel;
}> = ({ model: useModel }) => {
  const { title, order, limitationModel, supportAgeGenderLimitation } =
    useModel();

  return (
    <BatchEditCampaignPage title={title}>
      <div className={styles.modifyLimitationStateContent}>
        <EditLimitation
          model={limitationModel}
          order={order}
          renderGeneralFields={
            supportAgeGenderLimitation ? renderAgeAndGender : undefined
          }
        />
      </div>
    </BatchEditCampaignPage>
  );
};
